<template>
  <div class="search-input field has-dropdown">
    <div class="control">
      <div class="field has-addons">
        <div
          v-if="dropdown"
          class="control"
        >
          <dropdown
            v-model="localType"
            v-bind="attrs.dropdown || {}"
            :default-option="null"
            name="localType"
            :options="dropdown"
          />
        </div>
        <div class="control is-expanded-mobile">
          <input
            v-model="localSearch"
            v-bind="attrs.input || {}"
            class="input"
            type="text"
            :readonly="doingSearch"
          >
          <span
            v-if="localSearch !== ''"
            class="clear-button is-clickable"
            @click="clearSearchBar"
          >
            <i class="fas fa-times" />
          </span>
        </div>
        <div class="control">
          <button
            :class="{ 'is-loading': doingSearch }"
            :disabled="doingSearch"
            class="button search-button"
            @click.prevent="triggerSearch"
          >
            <span>Search</span>
            <span class="icon is-small">
              <i
                class="fas fa-search"
                aria-hidden="true"
              />
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Search",
  components: {},
  filters: {},
  inheritAttrs: false,
  props: {
    dropdown: {
      type: [ Object, Array ],
      default: null,
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    doingSearch: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [ String, Object ],
      default: '',
    },
  },
  data: function() {
    return {
      initialValues: '',
    };
  },
  computed: {
    localType: {
      get() {
        if (this.value instanceof Object) {
          return this.value.type;
        }
        return '';
      },
      set(newValue) {
        if (this.value instanceof Object) {
          this.$emit('input', { search: this.localSearch, type: newValue });
        }
      },
    },
    localSearch: {
      get() {
        if (this.value instanceof Object) {
          return this.value.search;
        }
        return this.value;
      },
      set(newValue) {
        if (this.value instanceof Object) {
          this.$emit('input', { search: newValue, type: this.localType });
        } else {
          this.$emit('input', newValue);
        }
      },
    },
  },
  watch: {
  },
  beforeMount() {
    this.initialValues = this.value;
  },
  methods: {
    clearSearchBar () {
      if (this.value instanceof Object) {
        this.localType = this.initialValues.type;
        this.localSearch = this.initialValues.search;
      } else {
        this.localSearch = this.initialValues;
      }
      this.$emit('clear');
    },
    triggerSearch() {
      if (this.doingSearch) {
        return;
      }
      if (this.type instanceof Object) {
        this.$emit('search', { search: this.localSearch, type: this.localType });
      } else {
        this.$emit('search', this.localSearch);
      }
    },
  },
};
</script>

<style lang="scss">
  #app {
    .search-input {
      @include mobile {
        .is-expanded-mobile {
          -webkit-box-flex: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
          -ms-flex-negative: 1;
          flex-shrink: 1;
        }
      }
      &.field {
        .control {
          .clear-button {
            font-size: 18px;
            line-height: 100%;
            color: $medium-gray;
            position: absolute;
            right: 2px;
            top: 50%;
            margin-top: -14px;
            z-index: 99;
            padding: 5px;
            &:hover {
              color: $dark-gray;
            }
          }
          .select {
            select {
              border: 2px solid $dark-ben-franklin;
            }
          }
          .input {
            border-width: 2px;
            min-width: 340px;
            @include until($tablet) {
              min-width: auto;
              width: 100%;
            }
            border: 2px solid $dark-ben-franklin;
          }
          .button {
            border: 2px solid $dark-ben-franklin;
            background-color: $dark-ben-franklin;
            border-width: 2px;
            border-color: $dark-ben-franklin;
            color: $white;
            height: 100%;
            width: 45px;
            font-size: 0;

            span {
              &:not(.icon) {
                font-size: 0;
              }
            }

            &:disabled,
            &[disabled],
            &[disabled="disabled"] {
              background-color: $dark-ben-franklin;
              opacity: 1;
            }
            
            &.is-loading {
              font-size: 1rem;
              &::after {
                border-bottom-color: $white;
                border-left-color: $white;
              }
            }
            .fas {
              font-size: initial;
            }
          }
        }
      }

      &.has-dropdown {
        .control {
          .select select {
            border-right: none;
          }
        }
      }
    }
  }
</style>